export const OPEN_MODAL = '@modal/OPEN_MODAL'
export const CLOSE_MODAL = '@modal/CLOSE_MODAL'
